import { useEffect, useState } from "react";
import { build, render } from "../../src/Folder";

export function FolderPicker() {
  const [files, setFiles] = useState<File[]>([]);
  const [tree, setTree] = useState<string>("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const picked = e.target.files;
    if (!picked) return;
    setFiles(Array.from(picked));
  };

  useEffect(() => {
    const arr: string[] = files.map((f) => f.webkitRelativePath)
    const folder = build(arr);

    setTree(
        render("", folder))
  }, [files]);

  return (
    <div>
      <input
      className="border p-2 w-auto mb-2"
        type="file"
        onChange={handleChange}
        // @ts-expect-error
        webkitdirectory=""
      />

      <pre>
        {tree}
      </pre>
    </div>
  );
}